import { render, staticRenderFns } from "./v-rrn-field.vue?vue&type=template&id=396488c6&"
import script from "./v-rrn-field.vue?vue&type=script&lang=js&"
export * from "./v-rrn-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports